import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    url: String
  }

  open(event) {
    event.preventDefault()

    document.dispatchEvent(new CustomEvent("reports-panel:open", {
      detail: {
        title: this.titleValue,
        url: this.urlValue
      }
    }))
  }
}
